import { useContext } from 'react';
import { z } from 'zod';

import { FormSchemaContext } from './FormSchemaContext';

const isFieldRequired = (
  schema: z.ZodType | undefined,
  fieldName: string,
): boolean => {
  if (schema instanceof z.ZodObject) {
    const field = schema.shape[fieldName] as z.ZodType;

    if (!field) {
      return false;
    }

    return !(
      field.safeParse(undefined).success || field.safeParse(null).success
    );
  }

  return false;
};

export const useFieldIsRequired = (fieldName: string) => {
  const context = useContext(FormSchemaContext);

  return isFieldRequired(context?.schema, fieldName);
};
